import Link from "next/link"

import { Img } from "@/components/ui/image"

const PokerstarsLogo = () => (
  <Link href={{ href: process.env.APP_MAIN_SITE_HOMEPAGE }} title="Pokerstars">
    <Img
      src="/assets/logo/logo-pokerstars.svg"
      alt="logo"
      width={114}
      height={20}
      className="max-h-7"
    />
  </Link>
)

export { PokerstarsLogo }
